// @ts-check
import { ModuleProcessMappings } from '@erpagroapp/common';
import {
  ConfigurationParameterReturnType,
  ConfigurationParameterSource,
} from '../enums';
import { defineConfig, defineDefaultProps } from '../helpers';

const defaultProps = defineDefaultProps(/** @type {const} */ ({
  loadingRules: {
    requiredModuleIds: [
      ModuleProcessMappings.Commercialisation.Id,
    ],
    requiredProcessIds: [
      ModuleProcessMappings.Commercialisation.Processes.PurchaseContracts.Id,
    ],
  },
}));

export function contracts() {
  return defineConfig({
    BloquearEnvioContratosNoConfirmados: {
      source: ConfigurationParameterSource.ERP,
      component: 'Comercializacion',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    PrefijoCodigoFinca: {
      source: ConfigurationParameterSource.ERP,
      component: 'SectorAgricola',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
  });
}
